import type { ReactNode } from 'react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import NewButton from 'ui/atoms/NewButton/NewButton'
import NewSwitch from 'ui/atoms/NewSwitch/NewSwitch'
import InfoBanner from 'ui/components/InfoBanner/InfoBanner'
import { useSnapshot } from 'valtio'
import { dayAheadBidTableStore } from '../../store/dayAheadBidTableStore'
import { DayAheadBidTable } from './DayAheadBidTable'
import type { DayAheadBidProductionConsumption, DayAheadBidTableResetController } from './DayAheadBidTable.types'
import { DayAheadBidTableSaveAction } from './DayAheadBidTableSaveAction'

type DayAheadBidTablePanelProps = {
  partitionId: number | undefined
  tableContextKey: string
  tableResetController: DayAheadBidTableResetController
}

export function DayAheadBidTablePanel({
  partitionId,
  tableContextKey,
  tableResetController,
}: DayAheadBidTablePanelProps): ReactNode {
  const { t } = useTranslation()
  const [productionConsumption, setProductionConsumption] = useState<DayAheadBidProductionConsumption>('production')
  const dayAheadBidTableSnap = useSnapshot(dayAheadBidTableStore)

  return (
    <div className="flex flex-col gap-3">
      <div className="flex w-full flex-wrap items-center gap-3">
        <NewSwitch
          items={[
            { value: 'production', label: t('Production') },
            { value: 'consumption', label: t('Consumption') },
          ]}
          value={productionConsumption}
          onClick={(value) => setProductionConsumption(value as DayAheadBidProductionConsumption)}
        />
        <div className="ml-auto flex items-center gap-3">
          {dayAheadBidTableSnap.hasPendingEdits && (
            <NewButton
              variant="outlined"
              label={t('Revert')}
              onClick={() => dayAheadBidTableStore.discardPendingEdits?.()}
            />
          )}
          <DayAheadBidTableSaveAction />
        </div>
      </div>
      <div className="flex justify-end">
        <InfoBanner
          style="info"
          text={t('Buy is entered as a positive volume. Sell is entered as a negative volume.')}
        />
      </div>
      <div>
        <DayAheadBidTable
          partitionId={partitionId}
          tableContextKey={tableContextKey}
          productionConsumption={productionConsumption}
          tableResetController={tableResetController}
        />
      </div>
    </div>
  )
}
